<div class="marv_card">
    <ng-content></ng-content>
</div>
